import { render, staticRenderFns } from "./WineryGeneral_Mobile.vue?vue&type=template&id=d2660ba8&scoped=true&"
import script from "./WineryGeneral_Mobile.vue?vue&type=script&lang=js&"
export * from "./WineryGeneral_Mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2660ba8",
  null
  
)

export default component.exports